import {
  MSI_FONT_FAMILY,
  MSI_GEOMETRY,
} from './msiStyleTokens';
import { buildMsiMuiComponentOverrides } from './msiMuiComponentOverrides';
import { buildMuiPalette, isThemeDark } from './themeTokens';

export function buildAppThemeOptions(themeId, compactMode) {
  const darkMode = isThemeDark(themeId);
  const msiComponents = buildMsiMuiComponentOverrides(themeId, compactMode);

  return {
    palette: buildMuiPalette(themeId),
    typography: {
      fontFamily: MSI_FONT_FAMILY,
      fontSize: compactMode ? 12 : 14,
      allVariants: { letterSpacing: 0 },
    },
    shape: { borderRadius: MSI_GEOMETRY.radii.base },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: darkMode ? 'none' : undefined,
          },
        },
      },
      MuiTableCell: { styleOverrides: { root: { padding: compactMode ? '2px 4px' : '6px 8px' } } },
      MuiContainer: { styleOverrides: { root: { padding: compactMode ? '8px' : '20px' } } },
      MuiTypography: {
        styleOverrides: {
          body1: { fontSize: compactMode ? '0.75rem' : '0.875rem' },
          h6: { fontSize: compactMode ? '0.9rem' : '1.25rem' },
        },
      },
      ...msiComponents,
    },
  };
}
